// ─── Score tier helpers ───────────────────────────────────────────────────────
export function scoreTier(score) {
    if (score >= 85)
        return { label: 'A+', color: 'text-emerald-400', ringColor: '#10b981', bg: 'bg-emerald-500/10' };
    if (score >= 70)
        return { label: 'A', color: 'text-emerald-300', ringColor: '#34d399', bg: 'bg-emerald-500/10' };
    if (score >= 55)
        return { label: 'B', color: 'text-yellow-400', ringColor: '#f59e0b', bg: 'bg-yellow-500/10' };
    if (score >= 40)
        return { label: 'C', color: 'text-orange-400', ringColor: '#f97316', bg: 'bg-orange-500/10' };
    return { label: 'D', color: 'text-red-400', ringColor: '#ef4444', bg: 'bg-red-500/10' };
}
// ─── R:R ratio display ────────────────────────────────────────────────────────
export function formatRRR(rrr) {
    return `1:${rrr.toFixed(2)}`;
}
// ─── Price formatting ─────────────────────────────────────────────────────────
export function formatPrice(price, pair) {
    if (pair.startsWith('BTC'))
        return price.toFixed(0);
    if (pair.startsWith('ETH') || pair.startsWith('BNB') || pair.startsWith('SOL') || pair.startsWith('AVA'))
        return price.toFixed(2);
    if (pair.startsWith('XRP') || pair.startsWith('ADA') || pair.startsWith('DOT'))
        return price.toFixed(4);
    if (pair.includes('JPY'))
        return price.toFixed(3);
    return price.toFixed(5);
}
// ─── Pip value calculation ────────────────────────────────────────────────────
export function calcPips(a, b, pair) {
    const multiplier = pair.includes('JPY') ? 100 : 10_000;
    return Math.abs(a - b) * multiplier;
}
// ─── Institutional action style map ──────────────────────────────────────────
export function actionStyle(action) {
    switch (action) {
        case 'Accumulation': return { border: 'border-indigo-500/50', bg: 'bg-indigo-500/10', text: 'text-indigo-300', dot: 'bg-indigo-400' };
        case 'Manipulation': return { border: 'border-amber-500/50', bg: 'bg-amber-500/10', text: 'text-amber-300', dot: 'bg-amber-400' };
        case 'Distribution': return { border: 'border-rose-500/50', bg: 'bg-rose-500/10', text: 'text-rose-300', dot: 'bg-rose-400' };
        case 'Expansion': return { border: 'border-emerald-500/50', bg: 'bg-emerald-500/10', text: 'text-emerald-300', dot: 'bg-emerald-400' };
    }
}
// ─── Market structure label ───────────────────────────────────────────────────
export function structureStyle(ms) {
    switch (ms) {
        case 'MSS': return { label: 'Market Structure Shift', color: 'text-violet-400' };
        case 'BOS': return { label: 'Break of Structure', color: 'text-sky-400' };
        case 'CHoCH': return { label: 'Change of Character', color: 'text-amber-400' };
        case 'Consolidation': return { label: 'Consolidation', color: 'text-gray-400' };
    }
}
// ─── Volume delta display ─────────────────────────────────────────────────────
export function formatVolumeDelta(delta) {
    const abs = Math.abs(delta);
    const sign = delta > 0 ? '+' : '-';
    if (abs >= 1000)
        return `${sign}${(abs / 1000).toFixed(1)}K`;
    return `${sign}${abs}`;
}
// ─── Relative volume level ────────────────────────────────────────────────────
export function rvLevel(rv) {
    if (rv >= 3)
        return { label: 'Extreme', color: 'text-red-400' };
    if (rv >= 2)
        return { label: 'High', color: 'text-amber-400' };
    if (rv >= 1.5)
        return { label: 'Elevated', color: 'text-yellow-400' };
    return { label: 'Normal', color: 'text-gray-400' };
}
// ─── OB / FVG helpers for chart overlay ──────────────────────────────────────
export function isOBVisible(ob, visibleRange) {
    return ob.timeStart <= visibleRange.to;
}
export function isFVGVisible(fvg, visibleRange) {
    return fvg.time >= visibleRange.from && fvg.time <= visibleRange.to;
}
// ─── Last candle direction ────────────────────────────────────────────────────
export function lastCandleDir(candles) {
    if (!candles.length)
        return 'doji';
    const c = candles[candles.length - 1];
    const body = Math.abs(c.close - c.open) / (c.high - c.low);
    if (body < 0.1)
        return 'doji';
    return c.close >= c.open ? 'bull' : 'bear';
}
